import { streamTextResponse } from '@/ai/api'
import { buildSwaggerFromCodePrompt } from '@/ai/prompts'

export const generateSwaggerFromCode = async ({
  aiVersion,
  codeSnippets,
  onChunkReceived,
  abortController
}) => {
  if (!aiVersion) {
    return null
  }

  const messages = buildSwaggerFromCodePrompt({ codeSnippets })

  const response = await streamTextResponse({
    messages,
    useCase: 'code-generation',
    aiVersion,
    onChunkReceived,
    signal: abortController?.signal
  })

  return response || null
}
